import Identifiable from 'interfaces/Identifiable';

import { PromptExecution, PromptTemplate } from './Prompt';


export interface PromptFlow extends Identifiable {
  id?: number;
  projectId: number;
  name: string;
  slug: string;
  metaTitle?: string;
  imageUrl?: string;
  metaDescription?: string;
  description?: string;
  metaKeywords?: string;
  authorId?: string;
  authorUrl?: string;
  version?: number;
  visibility: Visibility;
  systemMessage: string;
  examplePrompts: PromptExecution[];
  conversationTemplate: PromptTemplate[];
  targetAction: TargetAction;
  model: GptModel;
  temperature?: number;
  topP?: number;
  numChoicesPerMessage?: number;
  multipleStopSequences: string[];
  maxWords?: number;
  frequencyPenalty?: number;
  presencePenalty?: number;
  logitBias?: any[];
  promptCategoryId?: number;
}

export enum Visibility {
  Public = 'Public',
  Private = 'Private'
}

export enum TargetAction {
  GenerateThemeIdeas = 'GenerateThemeIdeas',
  GenerateTopicIdeas = 'GenerateTopicIdeas',
  GenerateArticleContent = 'GenerateArticleContent',
  GenerateArticleTitle = 'GenerateArticleTitle',
  GenerateLinkedInPost = 'GenerateLinkedInPost',
  GenerateFacebookPost = 'GenerateFacebookPost',
  GenerateTwitterPost = 'GenerateTwitterPost',
  GenerateArticleOutline = 'GenerateArticleOutline',
  Dynamic = 'Dynamic',
}

export enum GptModel {
  Gpt35Turbo = 'Gpt35Turbo', // 'gpt-3.5-turbo'
  Gpt4 = 'Gpt4', // 'gpt-4'
  Gpt4Turbo = 'Gpt4Turbo', // 'gpt-4-turbo'
  Gpt4o = 'Gpt4o', // 'gpt-4o'
  Gpt4oMini = 'Gpt4oMini', // 'gpt-4o-mini'
  ChatGPT4o = 'ChatGPT4o', // 'chatgpt-4o-latest'

  o3 = 'o3', // 'o3'
  o3Mini = 'o3Mini', // 'o3-mini'
  o3Pro = 'o3Pro', // 'o3-pro'
  o3DeepResearch = 'o3DeepResearch', // 'o3-deep-research'

  o4Mini = 'o4Mini', // 'o4-mini'
  o4MiniDeepResearch = 'o4MiniDeepResearch', // 'o4-mini' (deep research variant)

  Gpt41 = 'Gpt41', // 'gpt-4.1'
  Gpt41Mini = 'Gpt41Mini', // 'gpt-4.1-mini'
  Gpt41Nano = 'Gpt41Nano', // 'gpt-4.1-nano'

  Gpt5 = 'Gpt5', // 'gpt-5'
  Gpt5Mini = 'Gpt5Mini', // 'gpt-5-mini'
  Gpt5Nano = 'Gpt5Nano', // 'gpt-5-nano'
  Gpt5Chat = 'Gpt5Chat', // 'gpt-5-chat-latest'
}

export interface PromptFlowExecution {
  id?: number;
  projectId?: number;
  promptFlowId?: number;
  data?: any;
  errorMessage?: string;
  conversation: PromptExecution[];
  useAsFewShotExample?: boolean;
  lastResponse?: string;
  parsedResult?: any;
  hasError?: boolean;
}